import { ClientData } from "../types/auth";

export const TOKEN_KEY = "@egam2b-Token";
export const CLIENTE_KEY = "@egam2b-Cliente";
export const SOLAR_KEY = "@egam2b-Solar";
export const PEDIDO_KEY = "@egam2b-Pedido";

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getClientData = (): ClientData | null => {
  try {
    const data = localStorage.getItem(CLIENTE_KEY);
    if (!data) {
      return null;
    }
    const parsed = JSON.parse(data) as ClientData;
    // Retorna null se o objeto estiver vazio (após limpeza)
    if (Object.keys(parsed).length === 0) {
      return null;
    }
    return parsed;
  } catch (error) {
    // Se o JSON estiver corrompido, limpa o localStorage e retorna null
    // eslint-disable-next-line no-console
    console.error("Erro ao ler dados do cliente do localStorage:", error);
    localStorage.removeItem(CLIENTE_KEY);
    return null;
  }
};

export const login = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CLIENTE_KEY);
  localStorage.removeItem(PEDIDO_KEY);
  localStorage.removeItem(SOLAR_KEY);
};

export const client = (data: ClientData) => {
  localStorage.setItem(CLIENTE_KEY, JSON.stringify(data));
};

export const setNrPedidoAtivo = (nrPedido: string | null) => {
  if (nrPedido === null) {
    localStorage.removeItem(PEDIDO_KEY);
  } else {
    localStorage.setItem(PEDIDO_KEY, nrPedido);
  }
};

export const getNrPedidoAtivo = () => localStorage.getItem(PEDIDO_KEY);

export const campanhaSolar = (status: boolean) => {
  if (status === true) {
    localStorage.setItem(SOLAR_KEY, "true");
  } else {
    localStorage.removeItem(SOLAR_KEY);
  }
};

export const isCampanhaSolar = {
  get: () => localStorage.getItem(SOLAR_KEY) !== null,
};
